import { useState } from 'react';
import AdminPartners from './AdminPartners';
import AdminAlterations from './AdminAlterations';
import AdminInvoices from './AdminInvoices';
import AdminAllServices from './AdminAllServices';
import AdminAllClients from './AdminAllClients';
import AdminSettings from './AdminSettings';

type B2BTab = 'partners' | 'alterations' | 'invoices' | 'services' | 'clients' | 'settings';

export default function AdminB2B() {
  const [activeTab, setActiveTab] = useState<B2BTab>('partners');

  const tabs = [
    { id: 'partners', label: 'Marcas Partners', icon: 'ri-building-line' },
    { id: 'alterations', label: 'Solicitudes de Arreglos', icon: 'ri-scissors-cut-line' },
    { id: 'invoices', label: 'Facturación Mensual', icon: 'ri-file-list-3-line' },
    { id: 'services', label: 'Banco de Servicios', icon: 'ri-price-tag-3-line' },
    { id: 'clients', label: 'Directorio Clientes', icon: 'ri-group-line' },
    { id: 'settings', label: 'Mis Datos', icon: 'ri-settings-4-line' },
  ];

  return (
    <div className="space-y-8">
      {/* Sub-tabs for B2B */}
      <div className="flex items-center gap-1 bg-brand-gray-100/50 p-1 rounded-2xl w-fit overflow-x-auto max-w-full">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id as B2BTab)}
            className={`flex items-center gap-2 px-6 py-3 rounded-xl font-sans text-sm transition-all whitespace-nowrap ${
              activeTab === tab.id
                ? 'bg-white text-brand-black shadow-sm'
                : 'text-brand-gray-500 hover:text-brand-black'
            }`}
          >
            <i className={tab.icon} />
            {tab.label}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div className="animate-in fade-in slide-in-from-bottom-4 duration-500">
        {activeTab === 'partners' && <AdminPartners />}
        {activeTab === 'alterations' && <AdminAlterations />}
        {activeTab === 'invoices' && <AdminInvoices />}
        {activeTab === 'services' && <AdminAllServices />}
        {activeTab === 'clients' && <AdminAllClients />}
        {activeTab === 'settings' && <AdminSettings />}
      </div>
    </div>
  );
}
